"use strict";

import classNames from "classnames";
import React, { Component, PropTypes } from "react";

import FormComponentBase from ".\\FormComponentBase";

/******************************************************************************
** InputComponentBase
*/

export default class InputComponentBase extends FormComponentBase {

	static propTypes = {
		title: PropTypes.string,
		containerClassNames: PropTypes.string,
		labelClassNames: PropTypes.string,
		inputClassNames: PropTypes.string,
		showLabel: PropTypes.bool,
		showPlaceholder: PropTypes.bool,
		isRequired: PropTypes.bool,
		isRequiredMessage: PropTypes.string,
		validationExpression: PropTypes.string,
		validationMessage: PropTypes.string,
		defaultValue: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.array,
			PropTypes.string,
		]),
	};

	constructor(props) {
		super(props);
		this.state = Object.assign(this.state || {}, {
			isError: false,
			isErrorMessage: null,
			isErrorVisible: false,
			defaultValue: props.defaultValue,
			value: props.defaultValue || "",
			inputName: props.name,
			inputState: null,
			showLabelAsPlaceholder: typeof props.defaultValue == "undefined" || props.defaultValue == null || props.defaultValue.length === 0
		});
		this._onFocus = this._onFocus.bind(this);
		this._onBlur = this._onBlur.bind(this);
		this._onChange = this._onChange.bind(this);
		this._onInput = this._onInput.bind(this);
		this._onSubmit = this._onSubmit.bind(this);
	}

	resetDimensions() {
		super.resetDimensions();

		/*
		if (typeof this.refs.errorMessage == "undefined") {
			console.warn(`Can't resolve ref with name 'errorMessage' for component with name '${this.props.name}'.`);
			return;
		}
		if (typeof this.refs.input == "undefined") {
			console.warn(`Can't resolve ref with name 'input' for component with name '${this.props.name}'.`);
			return;
		}
		*/

		//this.validate();

		/*
		let $input = $(this._getUserInput());
		let inputWidth = $input.outerWidth();
		let inputLeft = $input.offset().left;
		let inputTop = $input.offset().top;

		let formDimensions = this.props.context.getFormDimensions();
		let formWidth = formDimensions.width;
		let formLeft = formDimensions.left;
		let formTop = formDimensions.top;

		let percent = formWidth / 100;
		let $left = inputLeft + inputWidth - formLeft;
		let $right = formWidth - (inputLeft - formLeft);
		let $top = inputTop - formTop;

		if (formWidth - $left > percent * 20) {
			this.setState({
				errMsg_isOnLeft: true,
				errMsg_left: $left / percent + "%",
				errMsg_top: $top
			});
		} else {
			this.setState({
				errMsg_isOnLeft: false,
				errMsg_right: $right / percent + "%",
				errMsg_top: $top
			});
		}
		*/
	}

	_getUserInput() {
		return this.refs.input;
	}

	isInputEmpty() {
		let $input = this._getUserInput();
		return $input.value == "";
	}

	isInputValid() {
		let $input = this._getUserInput();
		if (!this.props.validationExpression) {
			return true;
		}
		let regExp = new RegExp(this.props.validationExpression);
		return regExp.test($input.value);
	}

	updateInputState(inputState) {
		this.setState({ inputState });
		this.validate();
	}

	validate() {
		let isError = false;
		let isErrorMessage = null;
		if (this.state.inputState && !this.state.inputState.IsValid) {
			isError = true;
			isErrorMessage = this.state.inputState.ErrorMessage;
		} else if (this.isInputEmpty()) {
			if (this.props.isRequired) {
				isError = true;
				isErrorMessage = this.props.isRequiredMessage;
			}
		} else {
			if (!this.isInputValid()) {
				isError = true;
				isErrorMessage = this.props.validationMessage;
			}
		}
		this.setState({
			isError: isError,
			isErrorMessage: isErrorMessage
		});
		return isError;
	}

	isValid() {
		return !this.validate();
	}

	render() {
		let label = null;
		if (this.props.showLabel) {
			label = this.renderLabel(this.props.title);
		}
		let placeholder = null;
		if (this.props.showPlaceholder) {
			placeholder = this.props.title;
		}
		return (
				<div className={this.props.containerClassNames} ref="topContainer">
					<div className={classNames(this.props.inputClassNames, { "input-field_error": this.state.isError })}>
						<div className="input-field__wrapper">
							{label}
							{this.renderEditor(placeholder)}
						</div>
						{this.renderErrorMessageCtrl()}
					</div>
				</div>
			);
	}

	renderLabel(labelText) {
		let labelClassNames = classNames('input-field__label', { "input-field__label_placeholder": this.state.showLabelAsPlaceholder });
		return (<label htmlFor={this.state.clientId} className={labelClassNames}>{labelText}</label>);
	}

	renderEditor(placeholderText) {
		console.warn(`renderEditor() should be overrided in derived class for control with name '${this.props.name}'`);
		return null;
	}

	renderErrorMessageCtrl() {
		let $styles = { display: "none" };
		let $classNames = {
			"input-tooltip input-tooltip_valid": !this.state.isError,
			"input-tooltip input-tooltip_error": this.state.isError
		};
		if (this.state.isError && this.state.isErrorVisible) {
			/*
			Object.assign($classNames, {
				"left": this.state.errMsg_isOnLeft,
				"right": !this.state.errMsg_isOnLeft
			});
			*/
			Object.assign($styles,
				{ display: "block"/*, top: this.state.errMsg_top*/ }
				/*
				this.state.errMsg_isOnLeft
					? { left: this.state.errMsg_left }
					: { right: this.state.errMsg_right }
				*/
			);
		}
		return (
				<div ref="errorMessage" className={classNames($classNames)} style={$styles}>{this.state.isErrorMessage}</div>
			);
	}

	_onFocus() {
		this.setState({
			showLabelAsPlaceholder: false,
			isErrorVisible: true
		});
	}

	_onBlur() {
		this.validate();
		this.setState({
			showLabelAsPlaceholder: this.isInputEmpty(),
			isErrorVisible: false
		});
	}

	_onChange() {
		let value = this._getUserInput().value;
		//console.log(`onChange: ${value}`);
		this.setState({
			inputState: null,
			value: value
		});
		this.validate();
	}

	_onInput() {
		//console.log('onInput');
		//this.validate();
	}

	_onSubmit() {
		//console.log("onSumbit");
		//this.validate();
	}

}



/** WEBPACK FOOTER **
 ** ./forms/InputComponentBase.jsx
 **/